import React from 'react'
import Reflux from 'reflux-react-16'
import _ from 'lodash'

import {returnRefundMethods, returnReasons} from '../../../../utils/variables.js'

import LoginActions from '../../../actions/LoginActions.js'
import LoginStore from '../../../stores/LoginStore.js'

import carriers from '../../../../server/functions/parcels/carriers.js'
import countries from 'src/utils/Countries.js'
import naturalSort from 'src/utils/naturalSort.js'
import t from 'src/helpers/Languages.js'

import {
    Alert,
    Button,
    Card,
    H3,
    H5,
    S2,
    P,
    Toast,
    IconButton,
    Link
} from '../../../components/UI/index.js'
import Address from '../../../components/addresses/Address.js'
import {
    formSpacing,
    Check,
    CurrencyInput,
    FormRow,
    FormStack,
    Input,
    Toggle,
    Select
} from '../../../components/UI/forms/index.js'

export default class ReturnSettings extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {
            newReturnReason: '',
            error: '',
            retourCarriers: {},
            selectedReturnCountry: ''
        }

        this.store = LoginStore
    }

    componentDidMount() {
        const {reseller} = this.props
        const searchParams = new URLSearchParams(location.search)
        const code = searchParams.get('code')

        if (code) {
            LoginActions.installMollie(code, (err) => {
                if (err) {
                    console.log(err)
                }

                history.pushState('', '', '/klant/instellingen/retouren')
            })
        }

        const retourCarriers = {}

        Object.keys(reseller.settings.parcels.products.Retour).map((carrierName) => {
            if (reseller.settings.parcels.carriers[carrierName].enabled && reseller.settings.parcels.products.Retour[carrierName]) {
                const splittedCarrierName = carrierName.split('-')[0]

                carriers[carrierName]?.products?.Retour.countries?.map((countryCode) => {
                    retourCarriers[countryCode] = retourCarriers[countryCode] || {}
                    retourCarriers[countryCode][splittedCarrierName] = true
                })
            }
        })

        this.setState({retourCarriers, selectedReturnCountry: Object.keys(retourCarriers)[0]})
    }

    onChangeValue(path, event) {
        const user = {...this.props.user}

        if (path === 'settings.parcels.returnPortalURL') {
            _.set(user, path, event.target.value.toLowerCase())
        } else if (path === 'settings.parcels.returnPeriod') {
            _.set(user, path, parseInt(event.target.value))
        } else {
            _.set(user, path, event.target.value)
        }

        this.props.onChange(user)
    }

    onChangeChecked(path, event) {
        const user = {...this.props.user}

        _.set(user, path, event.target.checked)

        this.props.onChange(user)
    }

    onInstallMollie() {
        const clientId = 'app_YRTnv9PY29eKzLcvBBgrwy6y'
        const mollieAuthUrl = new URL('https://www.mollie.com/oauth2/authorize')

        const randomStr = Math.random().toString(36).substr(2, 5)

        mollieAuthUrl.searchParams.append('client_id', clientId)
        mollieAuthUrl.searchParams.append('state', randomStr)
        mollieAuthUrl.searchParams.append('scope', 'payments.read payments.write profiles.read')
        mollieAuthUrl.searchParams.append('response_type', 'code')
        mollieAuthUrl.searchParams.append('approval_prompt', 'force')

        location = mollieAuthUrl.href.replace(/\+/g, ' ')
    }

    onUninstallMollie() {
        const user = {...this.props.user}

        user.settings.parcels.mollie.accessToken = ''
        user.settings.parcels.mollie.websiteProfiles = []
        user.settings.parcels.mollie.active = false

        this.props.onChange(user, true)
    }

    onGetMollieProfiles() {
        this.setState({error: '', websiteProfilesLoading: true})

        LoginActions.getMollieProfiles((err) => {
            this.setState({error: err?.message, websiteProfilesLoading: false})
        })
    }

    onChangeWebsiteProfile(e) {
        const user = {...this.props.user}

        user.settings.parcels.mollie.websiteProfiles.map((profile) => profile.active = false)
        const activeIndex = user.settings.parcels.mollie.websiteProfiles.findIndex((profile) => profile.id === e.target.value)
        user.settings.parcels.mollie.websiteProfiles[activeIndex].active = true

        this.props.onChange(user)
    }

    onChangeReturnAddress(address) {
        const user = {...this.props.user}

        user.settings.parcels.returnAddress = address

        this.props.onChange(user)
    }

    onChangeReturnReasons(returnReason) {
        const user = {...this.props.user}

        const index = user.settings.parcels.returnReasons.findIndex((el) => el === returnReason)

        if (index === -1) {
            user.settings.parcels.returnReasons.push(returnReason)
        } else {
            user.settings.parcels.returnReasons.splice(index, 1)
        }

        this.props.onChange(user)
    }

    onClickAddReturnReason() {
        const user = {...this.props.user}

        user.settings.parcels.returnReasons.push(this.state.newReturnReason)

        this.setState({newReturnReason: ''})
        this.props.onChange(user)
    }

    onChangeRefundMethod(refundMethod) {
        const user = {...this.props.user}

        const index = user.settings.parcels.returnRefundMethods.findIndex((el) => el === refundMethod)

        if (index === -1) {
            user.settings.parcels.returnRefundMethods.push(refundMethod)
        } else {
            user.settings.parcels.returnRefundMethods.splice(index, 1)
        }

        this.props.onChange(user)
    }

    onNavigateToEmailNotifications() {
        const {history} = this.props

        history.push('/klant/instellingen/emailnotificaties', {selectedEmails: 'retourConfirmationEmails'})
    }

    render() {
        const {retourCarriers, selectedReturnCountry} = this.state
        const {user, reseller} = this.props

        return (
            <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                <H3 style={{marginBottom: 36}}>Retour instellingen</H3>

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Toggle
                        label='Retourportaal actief'
                        checked={user.settings.parcels.returnPortalActive}
                        onChange={this.onChangeChecked.bind(this, 'settings.parcels.returnPortalActive')}
                    />
                </FormStack>

                {!user.settings.parcels.returnPortalActive &&
                    <Alert variant='info' style={{marginTop: -10, marginBottom: 36}}>{t('returnPortalNotActive')}</Alert>
                }

                {user.settings.parcels.returnPortalActive && (
                    <>
                        <P>
                            {t('followThe')}{' '}
                            <Link style={{display: 'inline-block'}} href='https://handleiding.veloyd.nl/docs/retourportaal/'>{t('returnPortalManual')}</Link>
                            {' '}{t('toActivateReturnPortal')}
                        </P>

                        <div style={{display: 'flex', gap: formSpacing.tight, marginTop: 12, marginBottom: 12}}>
                            <P style={{marginTop: 18, marginRight: 12}}>{reseller.customBrandingEnabled && reseller.settings.domain ? reseller.settings.domain : 'app.veloyd.nl'}/retourportaal/</P>

                            <Input
                                label='Retourportaal URL'
                                info=''
                                value={user.settings.parcels.returnPortalURL || ''}
                                onChange={this.onChangeValue.bind(this, 'settings.parcels.returnPortalURL')}
                            />
                            <IconButton
                                onClick={() => {
                                    navigator.clipboard.writeText(`https://${reseller.customBrandingEnabled && reseller.settings.domain ? reseller.settings.domain : 'app.veloyd.nl'}/retourportaal/${user.settings.parcels.returnPortalURL}`).then(() => {
                                        this.toast.showToast('success', 'Link gekopieerd', 2500)
                                    })
                                }}
                            >
                                <i className='mdi mdi-content-copy' />
                            </IconButton>
                        </div>

                        {user.settings.parcels.returnPortalURL &&
                            <Alert variant='info' style={{marginTop: -10, marginBottom: 30}}>Let op! Als je de URL van het retourportaal wijzigt werken links naar het oude portaal niet meer.</Alert>
                        }

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Input
                                type='number'
                                label='Maximale retourperiode'
                                info='Hoeveel dagen na ontvangst kan de klant een bestelling retour sturen.'
                                min={14}
                                max={999}
                                value={user.settings.parcels.returnPeriod}
                                onChange={this.onChangeValue.bind(this, 'settings.parcels.returnPeriod')}
                            />

                            <Input
                                label='Retourbeleid URL'
                                info='Vul hier de URL in die verwijst naar de pagina op jullie website met informatie over retouren.'
                                value={user.settings.parcels.returnPolicyURL}
                                onChange={this.onChangeValue.bind(this, 'settings.parcels.returnPolicyURL')}
                            />
                        </FormStack>

                        <H5 style={{marginBottom: 24, marginTop: 36}}>Verzendkosten</H5>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Select
                                label='Retour vanuit'
                                value={this.state.selectedReturnCountry}
                                options={Object.keys(retourCarriers).map((countryCode) => ({
                                    value: countryCode,
                                    title: countries.find((country) => country.code2 === countryCode)?.name || countryCode
                                }))}
                                onChange={(event) => this.setState({selectedReturnCountry: event.target.value})}
                            />
                        </FormStack>

                        {naturalSort(Object.keys(retourCarriers[selectedReturnCountry] || {})).map((carrierName) => {
                            const onlyOneActive = Object.keys(user.settings.parcels.returnShippingCosts).filter((carrierName) => user.settings.parcels.returnShippingCosts?.[carrierName]?.enabled).length < 2 && user.settings.parcels.returnShippingCosts?.[carrierName]?.enabled

                            return (
                                <FormRow key={`returnCarrierCosts.${selectedReturnCountry}.${carrierName}`} style={{marginBottom: formSpacing.section + formSpacing.rowGap}}>
                                    <Check
                                        label={carrierName}
                                        checked={user.settings.parcels.returnShippingCosts?.[selectedReturnCountry]?.[carrierName]?.enabled}
                                        disabled={onlyOneActive}
                                        onChange={this.onChangeChecked.bind(this, `settings.parcels.returnShippingCosts.${selectedReturnCountry}.${carrierName}.enabled`)}
                                    />

                                    <CurrencyInput
                                        label='Verzendkosten'
                                        value={user.settings.parcels.returnShippingCosts?.[selectedReturnCountry]?.[carrierName]?.value || '0,00'}
                                        disabled={!user.settings.parcels.returnShippingCosts?.[selectedReturnCountry]?.[carrierName]?.enabled}
                                        onChange={this.onChangeValue.bind(this, `settings.parcels.returnShippingCosts.${selectedReturnCountry}.${carrierName}.value`)}
                                    />
                                </FormRow>
                            )
                        })}

                        {!user.settings.parcels.mollie.accessToken &&
                            <Button
                                style={{marginTop: 6}}
                                variant='outline'
                                icon='mdi mdi-link-variant'
                                label='Koppel Mollie'
                                onClick={this.onInstallMollie.bind(this)}
                            />
                        }

                        {user.settings.parcels.mollie.accessToken &&
                            <Button
                                style={{marginTop: 6}}
                                variant='outline'
                                icon='mdi mdi-link-variant-off'
                                label='Verbreek verbinding met Mollie'
                                onClick={this.onUninstallMollie.bind(this)}
                            />
                        }

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            {user.settings.parcels.mollie.accessToken &&
                                <Toggle
                                    label='Mollie actief'
                                    checked={user.settings.parcels.mollie.active}
                                    onChange={this.onChangeChecked.bind(this, 'settings.parcels.mollie.active')}
                                />
                            }

                            {user.settings.parcels.mollie.active && user.settings.parcels.mollie.accessToken &&
                                <div style={{display: 'flex', gap: formSpacing.tight}}>
                                    <Select
                                        label='Mollie website profielen'
                                        value={user.settings.parcels.mollie.websiteProfiles.find((profile) => profile.active)?.id}
                                        onChange={this.onChangeWebsiteProfile.bind(this)}
                                    >
                                        {user.settings.parcels.mollie.websiteProfiles.map((profile, index) => <option key={index} value={profile.id}>{profile.name}</option>)}
                                    </Select>

                                    <IconButton
                                        loading={this.state.websiteProfilesLoading}
                                        onClick={this.onGetMollieProfiles.bind(this)}
                                    >
                                        <i className='mdi mdi-refresh' />
                                    </IconButton>
                                </div>
                            }
                        </FormStack>

                        <H5 style={{marginBottom: 24, marginTop: 36}}>Retour redenen</H5>
                        <S2 style={{marginBottom: 24}}>Kies hieronder de redenen die getoond worden aan je klanten tijdens het aanmelden van een retour zending.</S2>

                        <div style={{overflowY: 'auto', maxHeight: 200, marginBottom: 24}}>
                            {_.uniq([...returnReasons, ...user.settings.parcels.returnReasons]).map((returnReason, index) => {
                                return (
                                    <Check
                                        key={`returnReason${index}`}
                                        checked={user.settings.parcels.returnReasons?.includes(returnReason)}
                                        label={returnReason}
                                        onChange={this.onChangeReturnReasons.bind(this, returnReason)}
                                    />
                                )
                            })}
                        </div>

                        <FormStack>
                            <Input
                                label='Retour reden'
                                value={this.state.newReturnReason}
                                onChange={(event) => this.setState({newReturnReason: event.target.value})}
                            />

                            <Button
                                variant='outline'
                                icon='mdi mdi-plus'
                                label='Nieuwe retour reden'
                                disabled={!this.state.newReturnReason}
                                onClick={this.onClickAddReturnReason.bind(this)}
                            />
                        </FormStack>

                        <H5 style={{marginBottom: 24, marginTop: 36}}>Retouradres</H5>

                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <Toggle
                                label='Gebruik afwijkend retouradres'
                                checked={user.settings.parcels.customReturnAddress}
                                onChange={this.onChangeChecked.bind(this, 'settings.parcels.customReturnAddress')}
                            />

                            {user.settings.parcels.customReturnAddress &&
                                <Address
                                    noCountry
                                    address={user.settings.parcels.returnAddress || {}}
                                    onChange={this.onChangeReturnAddress.bind(this)}
                                />
                            }
                        </FormStack>

                        <H5 style={{marginBottom: 24, marginTop: 36}}>Terugbetaling</H5>

                        {Object.keys(returnRefundMethods).map((key) => {
                            const refundMethod = returnRefundMethods[key]

                            return (
                                <Check
                                    key={key}
                                    label={refundMethod.title}
                                    checked={user.settings.parcels.returnRefundMethods?.includes(key)}
                                    onChange={this.onChangeRefundMethod.bind(this, key)}
                                />
                            )
                        })}

                        <Link style={{marginTop: 36}} onClick={this.onNavigateToEmailNotifications.bind(this)}>Retourbevestiging email instellingen</Link>
                    </>
                )}

                <Toast ref={(ref) => this.toast = ref}></Toast>
            </Card>
        )
    }
}
